import {ModuleWithProviders} from "@angular/core";
import {Routes, RouterModule} from "@angular/router";
import {BreachDetailsComponent} from "./breaches/breach-details.component";
import {BreachesListComponent} from "./breaches/breaches-list.component";

const routes: Routes = [
  {
    component: BreachesListComponent,
    data: {
      menuKey: "breachesList",
      title: "MAXsys | Breaches",
    },
    path: "breachesList",
  },
  {
    component: BreachesListComponent,
    data: {
      menuKey: "breachesList",
      title: "MAXsys | Breaches",
    },
    path: "breachesList/:venueId",
  },
  {
    component: BreachDetailsComponent,
    data: {
      menuKey: "breachesList",
      title: "MAXsys | Breaches",
    },
    path: "breachDetails/:venueId/:breachType/:dateDetected",
  },
  {
    data: {
      menuKey: "breachesList",
      title: "MAXsys | Breaches",
    },
    path: "",
    pathMatch: "full",
    redirectTo: "/breachesList",
  },
];

export const appRoutingProviders: any[] = [];

export const routing: ModuleWithProviders = RouterModule.forRoot(routes);



// WEBPACK FOOTER //
// ./client/app/app-routing.module.ts